export const monthSelectOptions = [
    { value: '01', label: 'Enero' },
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Mayo' },
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
];

export const yearSelectOptions = [
    { value: '2025', label: '2025' },
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: '2022', label: '2022' },
    { value: '2021', label: '2021' },
];

export const weekDays = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado']

export const getFirstDayOfMonth = (year, month) => new Date(year, month, 1);

export const getLastDayOfMonth = (year, month) => new Date(year, month + 1, 0);

export const getFirstDayOfYear = (year) => new Date(year, 0, 1);

export const getLastDayOfYear = (year) => new Date(year, 12, 0);

export const getCurrentDateToFormField = (date = new Date().toISOString()) => date.split("T")[0];

export const formatStringDate = (stringDate= '') => {
    if(stringDate == '')
        return null

    let arr = stringDate.split('/')
    return `${arr[2]}-${arr[1]}-${arr[0]}`
}

export const getDateToFormField = (inputDate) => {
    const date = Date.parse(inputDate)
    const actualDate = new Date()

    if(actualDate > date)
        return actualDate.toISOString().split("T")[0]

    return inputDate.split("T")[0]
}

export const getCurrentDateForCodeField = ( fecha = new Date()) => {
    // Obtener componentes de la fecha y hora
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const day = fecha.getDate().toString().padStart(2, '0');
    const hours = fecha.getHours().toString().padStart(2, '0');
    const minutes = fecha.getMinutes().toString().padStart(2, '0');
    const seconds = fecha.getSeconds().toString().padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`
}

/**
 * utilería para ordenar un arreglo de Strings con formato de hora. Todos los elementos de la lista
 * deben de tener el mismo formato de hora.
 * @param hours lista de Strings con formato de hora.
 */
export const sortHours = (hours = []) => {
    if(hours.length == 0)
        return []

    const actualDate = new Date().toISOString().split("T")[0]

    return hours.sort( (a, b) => {
        const timeA = new Date(`${actualDate}T${a}`);
        const timeB = new Date(`${actualDate}T${b}`);
        return timeA - timeB;
    })
}

/**
 * Cambiar el formato de 24hrs a uno de 12hrs.
 * @param timeValue hora a la que se quiere cambiar el formato.
 */
export const format24HourIn12Hours = timeValue => {
    const [hours, minutes] = timeValue.split(':');
    let hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? 'pm' : 'am';
    hour = hour % 12 || 12;

    return `${hour}:${minutes}${suffix}`;
}

export const getMinutesOfDay = () => {
    let times = [];
    for(let i = 0; i < 24; i++) {
        for(let j = 0; j < 60; j++) {
            let hour = i < 10 ? '0' + i : i;
            let minute = j < 10 ? '0' + j : j;
            times.push(hour + ':' + minute);
        }
    }
    return times;
}